import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { environment } from '@teem/environments/environment';

declare var $;

@Component({
  selector: 'settlements-tab-header',
  templateUrl: './settlements-tab-header.component.html'
})
export class SettlementsTabHeaderComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Input() settlementsCount;
  @Input() userInfo: any;
  @Output() onSearch: EventEmitter<string> = new EventEmitter();
  @Output('filterByDate') _filterByDate: EventEmitter<any> = new EventEmitter();
  @Output('filterByAmount') _filterByAmount: EventEmitter<any> = new EventEmitter();
  @Output('filterByStatus') _filterByStatus: EventEmitter<any> = new EventEmitter();
  isSearch: boolean = false;
  isFilter: boolean = false;
  fromDate: any;
  toDate: any;
  minAmount: any = '';
  maxAmount: any = '';
  params: any = {};

  constructor() { }

  ngOnInit(): void {
  }

  toggleSearch() {
    this.isSearch = !this.isSearch;

    if(this.isSearch) {
      this.searchInput.nativeElement.focus();
    } else {
      this.searchInput.nativeElement.value = "";
      this.onSearch.emit("");
    }
  }

  toggleFilter() {
    this.isFilter = !this.isFilter;
    this.params = {};
    this.resetDateFilters();
    this.resetAmountFilters();
    this.resetStatusFilters();
    setTimeout(() => {
      $('select[nice-select]').niceSelect('update');
    },100);
  }

  resetDateFilters() {
    if(this.fromDate || this.toDate) {
      this.fromDate = "";
      this.toDate = "";
      this.filterByDate();
    }
  }

  resetAmountFilters() {
    if(this.minAmount || this.maxAmount) {
      this.minAmount = "";
      this.maxAmount = "";
      this.filterByAmount();
    }
  }

  resetStatusFilters() {
   
  }


  filterByDate() {
    // if(this.fromDate) {
      this.params.from_date = this.fromDate;
    // }
    // if(this.toDate) {
      this.params.to_date = this.toDate; 
    // }

    this._filterByDate.emit(this.params);
  }

  filterByAmount() {
    // if(this.minAmount) {
      this.params.min_amount = this.minAmount;
    // }
    // if(this.maxAmount) {
      this.params.max_amount = this.maxAmount; 
    // }

    this._filterByAmount.emit(this.params);
  }

  filterByStatus() {
    this._filterByStatus.emit(this.params);
  }
}
